export function setClarityEvent(key: string, value: string) {

    if (!(key?.length > 0 && value?.length > 0)) {
        return;
    }
    
    try {
        (window as any)?.clarity("event", key + "-" + value);
    } catch {
        return;
    }
}

export function setClarityIdentify(user: any) {
    if (!(user?.email?.length > 0)) {
        return;
    }

    try {
        (window as any)?.clarity("identify", user.email);
        setClarityTag("user-email", user.email);
        setClarityTag("user-key", user.user_key);
    } catch {
        return;
    }
}

export function setClarityTag(key: string, value: string) {

    if (!(key?.length > 0 && value?.length > 0)) {
        return;
    }
    
    try {
        (window as any)?.clarity("set", key, value);
    } catch {
        return;
    }
}
